import { Services } from '@sigma-frontend-libs/commons'
import { TaskStates } from '@sigmasms/shared-types'

import { components, labelModes } from '@/utils'

import filterDate from '@/components/filter/date'
import filterDatePreset from '@/components/filter/date/preset'
import selectorOwner from '@/components/selector/owner'
import selectorSendingType from '@/components/selector/sendingType'
import { tasksStates } from '@/components/services/tasks/utils'
import tag from '@/components/tag'

function renderFieldSendingsType(h) {
  return h(
    selectorSendingType,
    {
      props: {
        value: this.proxy.data.sending.type,
        label: this.getTranslate(`${Services.tasks}.labels.type`),
        permission: `advanced.${Services.tasks}.find`
      },
      on: {
        input: event => {
          this.proxy.data.sending.type = event
        }
      }
    }
  )
}

function renderFieldContactList(h) {
  return h(
    components.select,
    {
      props: {
        value: this.proxy.ListId,
        label: this.getTranslate(`${Services.tasks}.labels.contactLists`),
        service: Services.contactLists,
        labelMode: labelModes.hidden,
        dense: true,
        clearable: true,
        details: false
      },
      on: {
        input: event => {
          this.proxy.ListId = event
        }
      }
    }
  )
}

function renderFieldState(h) {
  return h(
    components.select,
    {
      props: {
        value: this.proxy.state,
        label: this.getTranslate(`${Services.tasks}.labels.state`),
        items: Object.values(TaskStates).map(value => {
          return {
            title: this.getTranslate(`${Services.tasks}.states.${value}`),
            icon: tasksStates[value].icon,
            iconColor: tasksStates[value].color,
            value
          }
        }),
        labelMode: labelModes.hidden,
        dense: true,
        clearable: true,
        details: false
      },
      on: {
        input: event => {
          this.proxy.state = event
        }
      },
      scopedSlots: {
        selection: ({ item }) => {
          return h(
            tag,
            {
              props: {
                label: item.title,
                color: tasksStates[item.value].color,
                as: 'select-dense'
              }
            }
          )
        }
      }
    }
  )
}

function renderDateTimeFilter(h, field, fieldToClear) {
  return h(
    filterDate,
    {
      props: {
        value: this.proxy[field],
        title: field,
        label: field
      },
      on: {
        input: event => {
          if (event) {
            this.proxy.createdAtPreset = undefined
          }

          this.proxy[field] = event
          this.dropDateFilter(fieldToClear)
        }
      }
    }
  )
}

function renderCreatorSelect(h) {
  if (this.$route.name === Services.billings) {
    return h(
      selectorOwner,
      {
        props: {
          value: this.proxy.CreatorId,
          label: this.getTranslate(`${Services.tasks}.labels.creator`),
          labelMode: labelModes.hidden,
          dense: true
        },
        on: {
          input: event => {
            this.proxy.CreatorId = event
          }
        }
      }
    )
  } else {
    return h(
      components['text-field'],
      {
        props: {
          value: this.proxy.id,
          label: this.getTranslate(`${Services.tasks}.labels.id`),
          labelMode: labelModes.hidden,
          dense: true,
          clearable: true,
          details: false
        },
        on: {
          input: event => {
            this.proxy.id = event
          }
        }
      }
    )
  }
}

function renderFirstColumn(h) {
  return h(
    'div',
    {
      class: 'tasks-filter__column'
    },
    [
      h(
        selectorOwner,
        {
          props: {
            value: this.proxy.OwnerId,
            labelMode: labelModes.hidden,
            dense: true
          },
          on: {
            input: event => {
              this.proxy.OwnerId = event
            }
          }
        }
      ),

      renderCreatorSelect.call(this, h)
    ]
  )
}
function renderSecondColumn(h) {
  if (~this.type.indexOf('sendings:bulk')) {
    return h(
      'div',
      {
        class: 'tasks-filter__column'
      },
      [
        renderFieldSendingsType.call(this, h),
        renderFieldContactList.call(this, h)
      ]
    )
  }
}
function renderThirdColumn(h) {
  return h(
    'div',
    {
      class: 'tasks-filter__column'
    },
    [
      renderFieldState.call(this, h),
      renderDateTimeFilter.call(this, h, 'startsAt', 'createdAt')
    ]
  )
}
function renderFourthColumn(h) {
  return h(
    'div',
    {
      class: 'tasks-filter__column'
    },
    [
      h(
        filterDatePreset,
        {
          props: {
            value: this.proxy.createdAtPreset,
            labelMode: labelModes.hidden
          },
          on: {
            input: event => {
              if (event) {
                this.proxy.createdAt = {
                  $gt: undefined,
                  $lt: undefined
                }
              }

              this.proxy.createdAtPreset = event
            }
          }
        }
      ),

      renderDateTimeFilter.call(this, h, 'createdAt', 'startsAt')
    ]
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: {
        'tasks-filter': true,
        'grid-cols--4': this.viewport.breakpoint.lgUp && ~this.type.indexOf('sendings:bulk'),
        'grid-cols--3': this.viewport.breakpoint.md || !~this.type.indexOf('sendings:bulk') && this.viewport.breakpoint.lgUp,
        'grid-cols--2': this.viewport.breakpoint.sm
      }
    },
    [
      renderFirstColumn.call(this, h),
      renderSecondColumn.call(this, h),
      renderThirdColumn.call(this, h),
      renderFourthColumn.call(this, h)
    ]
  )
}
